import gql from 'graphql-tag';

const mutation = gql`
    mutation SaveOnboardingSettings(
        $sex: SexType
        $age: Int
        $height: UserMeasurementHeightInputType
        $weight: UserMeasurementWeightInputType
        $goalWeight: UserMeasurementWeightInputType
        $dietMode: DietModeType
        $triangleOfPower: DietTriangleOfPowerInputType
        $activityLevel: DietActivityLevelType
        $spontaneousActivityLevel: SpontaneousActivityLevelType
        $preferredMacronutrientRatio: MacronutrientRatioInputType
        $dietId: Int
        $dietType: DietOxyDietTypeType
        $exclusions: Int
        $muscleGroups: [MuscleGroupTypeEnum]
        $workoutLocation: [WorkoutLocationTypeEnum]
        $motivations: [MotivationEnum]
        $nutritionPreferences: [DietSourceEnum]
        $dietSource: DietSourceEnum
        $strengthTrainingExperience: StrengthTrainingExperienceEnum
        $hashimotoConditions: [HashimotoConditionEnum]
        $hashimotoSymptoms: [HashimotoSymptomEnum]
        $hashimotoGlp1Usage: HashimotoGlp1UsageEnum
        $hashimotoTsh: Float
        $preferredInstructors: [Int]
        $customAttributes: [CustomAttributeInputType]
        $fastingDietProgramme: DietWithFastingDietProgrammeType
        $fastType: DietWithFastingHealthyEatingFastTypeType
        $fastDays: Int
        $fastPreparationDays: Int
        $fastingDietType: DietWithFastingHealthyEatingDietTypeType
        $fastDayOfTheWeek: DayOfTheWeekType
        $regularActivityLevel: DietWithFastingRegularActivityLevelType
    ) {
        me {
            saveOnboardingSettings(
                sex: $sex
                age: $age
                height: $height
                weight: $weight
                goalWeight: $goalWeight
                dietMode: $dietMode
                triangleOfPower: $triangleOfPower
                activityLevel: $activityLevel
                spontaneousActivityLevel: $spontaneousActivityLevel
                preferredMacronutrientRatio: $preferredMacronutrientRatio
                dietId: $dietId
                dietType: $dietType
                exclusions: $exclusions
                muscleGroups: $muscleGroups
                workoutLocation: $workoutLocation
                motivations: $motivations
                nutritionPreferences: $nutritionPreferences
                dietSource: $dietSource
                strengthTrainingExperience: $strengthTrainingExperience
                hashimotoConditions: $hashimotoConditions
                hashimotoSymptoms: $hashimotoSymptoms
                hashimotoGlp1Usage: $hashimotoGlp1Usage
                hashimotoTsh: $hashimotoTsh
                preferredInstructors: $preferredInstructors
                customAttributes: $customAttributes
                fastingDietProgramme: $fastingDietProgramme
                fastType: $fastType
                fastDays: $fastDays
                fastPreparationDays: $fastPreparationDays
                fastingDietType: $fastingDietType
                fastDayOfTheWeek: $fastDayOfTheWeek
                regularActivityLevel: $regularActivityLevel
            ) {
                __typename
                ... on BasicMutationSuccess {
                    code
                }
                ... on UnauthorizedException {
                    code
                }
                ... on ValidationException {
                    code
                    messages
                    details {
                        fieldName
                        messages
                    }
                }
            }
        }
    }
`;

export default mutation;
